// Simple CSS Light Rays from sun
import React from 'react';
import './LightRaysCustom.css';

const LightRaysCustom = () => {
  const rays = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    angle: i * 15,
    opacity: 0.15 + Math.random() * 0.15,
    width: 80 + Math.random() * 60,
  }));

  return (
    <div className="light-rays-container">
      {rays.map((ray) => (
        <div
          key={ray.id}
          className="light-ray"
          style={{
            transform: `rotate(${ray.angle}deg)`,
            opacity: ray.opacity,
            width: `${ray.width}px`,
          }}
        />
      ))}
    </div>
  );
};

export default LightRaysCustom;
